// Shared, dedupe-aware weekly-hours helpers used across the schedule UI.
// IMPORTANT: when one staff member is assigned to multiple participants (or
// groups) in the SAME time block on the SAME day, the row count multiplies
// but the actual hours don't. Always merge overlapping/identical intervals
// per (date) before summing.

const toMin = (t) => {
  const [h, m] = String(t).split(':').map(Number);
  return (h || 0) * 60 + (m || 0);
};

// Returns total hours across one staff's shifts after merging overlapping
// intervals per day. Accepts shifts with shape { date, time_in, time_out }.
export function computeMergedHours(shifts) {
  if (!shifts?.length) return 0;
  const byDay = {};
  for (const s of shifts) {
    if (!s?.time_in || !s?.time_out || !s?.date) continue;
    const start = toMin(s.time_in);
    const end = toMin(s.time_out);
    if (end <= start) continue;
    (byDay[s.date] = byDay[s.date] || []).push([start, end]);
  }
  let totalMin = 0;
  for (const day of Object.keys(byDay)) {
    const iv = byDay[day].sort((a, b) => a[0] - b[0]);
    let [curS, curE] = iv[0];
    for (let i = 1; i < iv.length; i++) {
      const [s, e] = iv[i];
      if (s <= curE) {
        if (e > curE) curE = e;
      } else {
        totalMin += curE - curS;
        [curS, curE] = [s, e];
      }
    }
    totalMin += curE - curS;
  }
  return totalMin / 60;
}

// Filter helper for the schedule grid: shifts in a given list of YYYY-MM-DD
// dates that belong to a given employee_id (skips unassigned rows).
export function shiftsForEmployeeInDates(shifts, employeeId, dateStrings) {
  if (!shifts?.length || !employeeId) return [];
  const dateSet = new Set(dateStrings || []);
  return shifts.filter(
    (s) => s.employee_id === employeeId && dateSet.has(s.date)
  );
}
